<div class="wccard mb-1 p-3">
  <div class="d-flex mb-2">
    <div>
      <div class="compLogoIcon mr-3 bg-gray-new">
        <i class="fa-solid fa-buildings text-webbtree-green" *ngIf="!companyDetails?.companylogo"></i>
        <img [src]="companyDetails?.companylogo" alt="companyDetails?.name" *ngIf="companyDetails?.companylogo">
      </div>
    </div>
    <div class="d-flex justify-content-between w-100">
      <div class="w-100">
            <div class="d-flex justify-content-between align-items-center">
              <div class="d-flex">
                <div class="">
                  <p class="f-14 font-weight-600 text-484b59 mb-1 pointer" (click)="redirecttoCompanylist(companyDetails)" *ngIf="companyDetails?.name">{{companyDetails?.name |
                    titlecase}}</p>
                </div>
              </div>
            </div>
            <div>
              <p class="f-12 text-484b59 mb-1" *ngIf="companyDetails?.industry">{{companyDetails?.industry | titlecase}}
              </p>
              <div class="f-12 d-flex align-items-center">
                <span matTooltip="Founded On" [matTooltipClass]="{ 'red-tooltip text-black': true }" class="text-9696 "
                  *ngIf="companyDetails?.founded"><i class="fa-regular fa-flag mr-2"></i>
                  <span>{{companyDetails?.founded}}</span></span>
                <i class="fa-solid fa-circle mx-2" style="font-size:3px; color: #d9d9d9;"
                  *ngIf="companyDetails?.founded && companyDetails?.location?.name"></i>
                <span matTooltip="Location" [matTooltipClass]="{ 'red-tooltip text-black': true }" class="text-9696"
                  *ngIf="companyDetails?.location?.name"><i class="fa-regular fa-buildings mr-2"></i>
                  <span>{{companyDetails?.location?.name | titlecase}}</span></span>
                <i class="fa-solid fa-circle mx-2" style="font-size:3px; color: #d9d9d9;"
                  *ngIf="companyDetails?.size && companyDetails?.location?.name"></i>
                <span matTooltip="Company Size" [matTooltipClass]="{ 'red-tooltip text-black': true }" class="text-9696 "
                  *ngIf="companyDetails?.size"><i class="fa-regular fa-users mr-2"></i>
                  <span>{{companyDetails?.size}}</span></span>
                <i class="fa-solid fa-circle mx-2" style="font-size:3px; color: #d9d9d9;"
                  *ngIf="companyDetails?.size && companyDetails?.linkedin_url"></i>
                <span class="" >
                  <a data-testid="auto-app-webbtree-company-details-a-1" target="_blank" (click)="openUrl(companyDetails?.linkedin_url, 'linkedin')"
                    *ngIf="companyDetails?.linkedin_url">
                    <i class="fab fa-linkedin ml-3" style="color: #2F6DA7!important"></i>
                  </a>
                  <a data-testid="auto-app-webbtree-company-details-a-2" target="_blank" (click)="openUrl(companyDetails?.twitter_url, 'twitter')"
                    *ngIf="companyDetails?.twitter_url">
                    <i class="fa-brands fa-square-x-twitter ml-2" style="color: #000000!important"></i>
                  </a>
                  <a data-testid="auto-app-webbtree-company-details-a-3" target="_blank" (click)="openUrl(companyDetails?.facebook_url, 'facebook')"
                    *ngIf="companyDetails?.facebook_url">
                    <i class="fab fa-facebook ml-2" style="color: #2F6DA7!important"></i>
                  </a>
                </span>
              </div>
            </div>
      </div>

      <div>
          <div class="d-flex">
            <button data-testid="auto-app-webbtree-company-details-button-1" class="btn-trms-regular" [ngClass]="{'disable-compare': getDisabledCompareButton(companyDetails.id)}" (click)="scrollTOCompareCompany(companyDetails)">
              Compare
            </button>
            <button data-testid="auto-app-webbtree-company-details-button-2"  class="ml-2 btn-trms-small px-0" (click)="redirecttoCompanylist(companyDetails)">
              View Insights
            </button>
          </div>
      </div>
    </div>
  </div>
  <div class="compDetail">
    <div class="f-12 d-flex align-items-center">
      <span *ngIf="companyDetails?.type">
        <i class="fa-regular fa-users mr-2"></i>
        <span >{{companyDetails?.type | titlecase}}</span>
      </span>
      <i class="fa-solid fa-circle mx-2" style="font-size:4px; color: #2E93A1;" *ngIf="companyDetails?.type && companyDetails?.total_funding_raised"></i>
      <span *ngIf="companyDetails?.total_funding_raised">
        <i class="fa-regular fa-hand-holding-circle-dollar mr-2"></i>
        <span>${{formatNumberToIndianFormat(companyDetails?.total_funding_raised)}} Raised</span>
      </span>
      <!-- <i class="fa-solid fa-circle mx-2" style="font-size:4px; color: #2E93A1;"></i>
      <span>
        <i class="fa-regular fa-hourglass-half mr-2"></i>
        <span>5.2 yrs</span>
      </span> -->
      <i class="fa-solid fa-circle mx-2" style="font-size:4px; color: #2E93A1;" *ngIf="companyDetails?.total_funding_raised && companyDetails?.number_funding_rounds && !companyDetails?.total_funding_raised"></i>
      <i class="fa-solid fa-circle mx-2" style="font-size:4px; color: #2E93A1;" *ngIf="companyDetails?.type && companyDetails?.number_funding_rounds"></i>

      <span *ngIf="companyDetails?.number_funding_rounds">
        <i class="fa-solid fa-stairs mr-2"></i>
        <span>{{companyDetails?.number_funding_rounds}} funding rounds </span>
      </span>
      <i class="fa-solid fa-circle mx-2" style="font-size:4px; color: #2E93A1;" *ngIf="companyDetails?.number_funding_rounds && companyDetails?.latest_funding_stage"></i>
      <i class="fa-solid fa-circle mx-2" style="font-size:4px; color: #2E93A1;" *ngIf="companyDetails?.type && companyDetails?.latest_funding_stage && !companyDetails?.total_funding_raised"></i>
      <i class="fa-solid fa-circle mx-2" style="font-size:4px; color: #2E93A1;" *ngIf="companyDetails?.total_funding_raised && companyDetails?.latest_funding_stage && !companyDetails?.type"></i>

      <span *ngIf="companyDetails?.latest_funding_stage">
        <i class="fa-regular fa-seedling mr-2"></i>
        <span>{{companyDetails?.latest_funding_stage | titlecase}}</span>
      </span>
    </div>
    <!-- <div>
      <span class="text-484b59 font-weight-500 f-12">+{{companyDetails?.tags?.length}} More Tags</span>
    </div> -->
  </div>

<div class="row">
  <div class="f-12 col-8">
   <div class="row">
    <div class="col">
        <p class="f-14 font-weight-500 mb-0 d-flex align-items-center text-484b59">
          <span class="mb-1">{{totalresultscount}}</span>
          <span *ngIf="!totalresultscount">_</span>
        </p>
        <p class="f-10 text-9696 mb-0">Professionals</p>
      </div>
      <div class="col">
      <p class="f-14 font-weight-500 mb-0 d-flex align-items-center text-484b59"><span class="mb-1" *ngIf="!medianTenureLoader" [innerHTML]="getFormattedTenureForMatrix(medianTanuresCount)"></span>
      <span *ngIf="medianTenureLoader">_</span>
      </p>
      <p class="f-10 text-9696  mb-0">Median Tenure </p>
      </div>
      <div class="col">
    <p class="f-14 font-weight-500 mb-0 d-flex align-items-center text-484b59"><span class="mb-1" *ngIf="!recentHiresLoader">{{hiresAndAttritionObj?.recentGrowth?.currentYearCount}}</span>
       <span *ngIf="recentHiresLoader">_</span>
    </p>
    <p class="f-10 text-9696  mb-0">Recent Hires (1 Yr)</p>
      </div>
      <div class="col">
        <p class="f-14 font-weight-500 mb-0 d-flex align-items-center text-484b59"><span class="mb-1">{{hiresAndAttritionObj?.recentAttrtion?.currentYearCount}}
        </span> <span class="d-flex"></span>
      <span *ngIf="!hiresAndAttritionObj?.recentAttrtion?.currentYearCount">_</span>
      </p>
        <p class="f-10 text-9696  mb-0">Recent Attrition (1 Yrs)</p>
      </div>
   </div>
  </div>
</div>
